import { gql } from 'apollo-angular';

export const UserEndedOnboardingDocument = gql`
  mutation userEndedOnboarding {
    userEndedOnboarding {
      id
    }
  }
`;
